export function currencySymbol(currency: string | undefined | null): string {
  switch (currency?.toUpperCase()) {
    case 'EUR': return '€';
    case 'USD': return '$';
    case 'GBP': return '£';
    default: return currency ?? '';
  }
}
